import { render, staticRenderFns } from "./OrgSaasDashboard.vue?vue&type=template&id=693f6c9b&scoped=true"
import script from "./OrgSaasDashboard.vue?vue&type=script&lang=js"
export * from "./OrgSaasDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrgSaasDashboard.vue?vue&type=style&index=0&id=693f6c9b&prod&scoped=true&lang=css"
import style1 from "./OrgSaasDashboard.vue?vue&type=style&index=1&id=693f6c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693f6c9b",
  null
  
)

export default component.exports